import { Injectable } from '@angular/core';
import { IFilter } from '@shared/interfaces/IFilter';
import { isArray } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { IBase } from '@shared/interfaces';

@Injectable({
    providedIn: 'root'
})
export class FilterService {
    data: IBase[];
    onFilter = new BehaviorSubject<boolean>(false);
    private previousFilters: Array<IFilter> = [];
    private textFilter: string;

    applyFilter(filter?: IFilter, reload = false) {
        if (!reload) {
            this.previousFilters = this.previousFilters.filter(e => e.selected);
            for (const item of this.data.filter(e => !e.textFiltered)) {
                item.filtered = false;
                item.filteredBy = null;
            }
            for (const item of this.previousFilters) {
                this.applyFilter(item, true);
            }
        }

        if (filter) {
            if (filter.searchFor) {
                if (filter.value !== null) {
                    this.previousFilters = this.previousFilters.filter(e => e.searchFor !== filter.searchFor);
                    this.previousFilters.push(filter);
                    if (filter.searchFor.indexOf('.') >= 0) {
                        const [parent, child] = filter.searchFor.split('.');
                        for (const item of this.data.filter(e => !e.textFiltered && !e.filtered)) {
                            item.filtered =
                                filter.exists !== undefined
                                    ? filter.exists
                                        ? !!item[parent][child]
                                        : !item[parent][child]
                                    : item[parent]
                                      ? !isArray(filter.value)
                                          ? `${item[parent][child]}` !== `${filter.value}`
                                          : filter.value.length &&
                                            !filter.value.some(e => item[parent] && e === `${item[parent][child]}`)
                                      : true;
                            item.filteredBy = item.filtered ? filter.searchFor : null;
                        }
                    } else {
                        for (const item of this.data.filter(e => !e.textFiltered && !e.filtered)) {
                            item.filtered =
                                filter.exists !== undefined
                                    ? filter.exists
                                        ? !!item[filter.searchFor]
                                        : !item[filter.searchFor]
                                    : !isArray(filter.value)
                                      ? `${item[filter.searchFor]}` !== `${filter.value}`
                                      : !filter.value.some(e => e === `${item[filter.searchFor]}`);
                            item.filteredBy = item.filtered ? filter.searchFor : null;
                        }
                    }
                } else {
                    for (const item of this.data.filter(e => !e.textFiltered && e.filteredBy === filter.value)) {
                        item.filtered = false;
                        item.filteredBy = null;
                    }
                }
            } else if (filter.groupBy) {
                this.data.sort((a, b) => {
                    const [aVal, bVal] =
                        filter.groupBy.indexOf('.') >= 0
                            ? (() => {
                                  const [parent, child] = filter.groupBy.split('.');
                                  return [a[parent][child], b[parent][child]];
                              })()
                            : [a[filter.groupBy], b[filter.groupBy]];

                    if (aVal > bVal) {
                        return 1;
                    }
                    if (aVal < bVal) {
                        return -1;
                    }
                    return 0;
                });
            }
        }
        this.onFilter.next(true);
    }

    applyTextFilter(value: string) {
        this.textFilter = value;
        if (this.data) {
            if (this.textFilter) {
                for (const item of this.data.filter(e => (!e.filtered && !e.filteredBy) || e.textFiltered)) {
                    item.filtered = item.textFiltered = !this.checkObject(item, `${this.textFilter}`);
                }
            } else {
                for (const item of this.data) {
                    item.filtered = item.textFiltered = false;
                    this.setUnfilteredForObjects(item);
                }
            }
            this.applyFilter();
        }
    }

    checkObject(item, check: string) {
        let filtered = false;
        for (const key of Object.keys(item)) {
            if (item[key] instanceof Array) {
                for (const element of item[key]) {
                    const itemFiltered = this.checkObject(element, check);
                    if (element instanceof Object) {
                        element.filtered = element.textFiltered = !itemFiltered;
                    }
                    if (itemFiltered) {
                        filtered = true;
                    }
                }
            } else if (item[key] instanceof Object) {
                const itemFiltered = this.checkObject(item[key], check);
                if (itemFiltered && !filtered) {
                    item[key].filtered = item[key].textFiltered = false;
                    filtered = true;
                } else {
                    item[key].filtered = item[key].textFiltered = true;
                }
            } else if (`${item[key]}`.toLowerCase().indexOf(check.toLowerCase()) >= 0 && !filtered) {
                filtered = true;
            }
        }
        return filtered;
    }

    setUnfilteredForObjects(item) {
        for (const key of Object.keys(item)) {
            if (item[key] instanceof Array) {
                for (const element of item[key]) {
                    this.setUnfilteredForObjects(element);
                }
            }
            if (item[key] instanceof Object) {
                this.setUnfilteredForObjects(item[key]);
                item[key].filtered = item[key].textFiltered = false;
            }
        }
    }

    reset() {
        this.data = this.textFilter = null;
        this.previousFilters = [];
    }
}
